import React from 'react';
import { Router } from 'react-router-dom';

import createBrowserHistory from 'history/createBrowserHistory';
import Layout from './customModules/Layout/component-layout';

import { passHistoryToSuperagentIntercept } from './customModules/Common/rest-api/api-requests';

const history = createBrowserHistory();

passHistoryToSuperagentIntercept(history);

export default function App() {
    return (
        <div className="pharmacy-app">
            <Router history={history}>
                <Layout />
            </Router>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/App.js